export const getApiErrorPresentation = (error, fallbackMessage = 'Permintaan gagal.') => {
  const payload = error?.response?.data;
  const detail = payload?.detail;
  const structured = detail && typeof detail === 'object' && !Array.isArray(detail)
    ? detail
    : payload?.error;
  const message = structured?.message
    || (typeof detail === 'string' ? detail : null)
    || payload?.message
    || error?.message
    || fallbackMessage;
  const code = structured?.code || structured?.error_code;
  const stage = structured?.stage;
  const invalidChunks = Array.isArray(structured?.invalid_chunks)
    ? structured.invalid_chunks
    : [];

  const chunkLines = invalidChunks.slice(0, 5).map((chunk) => {
    const reasons = (chunk.reasons || [])
      .map((reason) => reason.message || reason.code)
      .filter(Boolean)
      .join('; ');
    const preview = chunk.preview ? ` — “${chunk.preview}”` : '';
    return `Chunk ${chunk.chunk_index} [${chunk.chunk_type || '-'}]: ${reasons || 'Tidak valid'}${preview}`;
  });
  const remaining = Number(structured?.invalid_chunk_count || invalidChunks.length) - chunkLines.length;
  if (remaining > 0) chunkLines.push(`...dan ${remaining} chunk lainnya.`);

  const retryHint = structured?.retryable === true
    ? 'Error ini bersifat sementara; silakan coba lagi.'
    : structured?.retryable === false
      ? 'Perbaiki penyebab di atas sebelum mencoba lagi.'
      : null;

  return {
    title: code ? `Proses gagal (${code})` : 'Proses gagal',
    text: [
      message,
      stage ? `Tahap: ${stage}.` : null,
      ...chunkLines,
      retryHint,
    ].filter(Boolean).join('\n\n'),
  };
};
